// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/gust-corrected-approach-speed.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/gust-corrected-approach-speed/gust-corrected-approach-speed.js';

mount([g0]);
